module.exports = __webpack_public_path__ + "img/t-2.3ff1b488.png";